import React, { Fragment, Component } from 'react';
import { Formik, Field, FieldArray, Form } from 'formik';
import moment from 'moment';
import isEqual from 'lodash/isEqual';
import isEmpty from 'lodash/isEmpty';
import cloneDeep from 'lodash/cloneDeep';
import * as Yup from 'yup';

import { sortByStartDate } from './utils';

import { getCustomToast } from '../../components/ErrorMessage';
import { MobileScreen } from '../../components/ResponsiveScreens';

import { isBrowser } from '../../lib/utils';
import api from '../../lib/api';
import '../../../node_modules/flatpickr/dist/themes/airbnb.css';

let Flatpickr = '';

if (isBrowser()) Flatpickr = require('react-flatpickr').default;

const commonFlatPickerConfig = {
  mode: 'range',
  minDate: 'today',
  disableMobile: 'true',
  altInput: true,
  altFormat: 'F j, Y',
  dateFormat: 'Y-m-d',
};

const reformatErrors = error => {
  const invalidDate = '`date` type';
  const errorMessage = 'Required!';
  if (error && error.includes(invalidDate) && error.includes('start_date'))
    return errorMessage;
  if (error && error.includes(invalidDate) && error.includes('end_date'))
    return errorMessage;
  return error;
};

const schema = Yup.object().shape({
  upcoming_treks: Yup.array().of(
    Yup.object().shape({
      title: Yup.string()
        .min(4, 'Too Short')
        .required('Required'),
      start_date: Yup.date().required('Required'),
      end_date: Yup.date()
        .test('match', 'Invalid Date!', function(end_date) {
          return !moment(end_date).isSame(this.options.parent.start_date);
        })
        .test('match', 'Invalid Date!', function(end_date) {
          return moment(end_date).isAfter(this.options.parent.start_date);
        })
        .required('Required'),
    })
  ),
});

const CustomInputComponent = ({
  index,
  singleTrek,
  //   touched,
  errors,
  values,
  setValues,
}) => {
  function handleClose(selectedDates) {
    const startDate = moment(selectedDates[0]).format('YYYY-MM-DD');
    const endDate = moment(selectedDates[1]).format('YYYY-MM-DD');

    const newValues = cloneDeep(values);
    newValues.upcoming_treks[index].start_date = startDate;
    newValues.upcoming_treks[index].end_date = endDate;

    setValues({
      ...values,
      ...newValues,
    });
  }

  return isBrowser() ? (
    <div>
      <Flatpickr
        id={`flatpickr${index}`}
        options={{
          ...commonFlatPickerConfig,
          defaultDate: [`${singleTrek.start_date}`, `${singleTrek.end_date}`],
        }}
        onClose={handleClose}
        placeholder="Select Date.."
        className="form-control datepicker"
      />
      {errors.upcoming_treks && errors.upcoming_treks[index] && (
        <div className="error">
          {reformatErrors(errors.upcoming_treks[index].start_date)
            ? reformatErrors(errors.upcoming_treks[index].start_date)
            : reformatErrors(errors.upcoming_treks[index].end_date)}
        </div>
      )}
    </div>
  ) : null;
};

export default class UpCome extends Component {
  state = { isEditing: false };

  render() {
    const { isEditing } = this.state;
    return (
      <Fragment>
        <div className="profile">
          {isEditing ? this.renderForm() : this.renderUpComingTrek()}
        </div>
      </Fragment>
    );
  }

  renderUpComingTrek = () => {
    const { data: upcomingTrekData, isViewingOwnProfile } = this.props;
    return (
      <Fragment>
        <h2>
          UpComing Treks{' '}
          {isViewingOwnProfile ? (
            <span className="edit" onClick={this.handleEditPress}>
              <i className="icon icon-hg-edit-pencil" aria-hidden="true" /> Edit
            </span>
          ) : null}
        </h2>
        <div className="upcomming-teks">
          <div className="trek-row trek-row-head">
            <div className="trek-date">Start date - End date</div>
            <div className="trek-name">Trek name</div>
          </div>
          {isEmpty(upcomingTrekData) ? (
            isViewingOwnProfile ? (
              <div className="no-message">You do not have any upcoming treks. Add one!</div>
            ) : (
              <div className="no-message">There are no upcoming treks</div>
            )
          ) : (
            upcomingTrekData.map((trek, i) => {
              const endDate = moment(trek.end_date).format('MMM D, YYYY');
              const startDate = moment(trek.start_date).format('MMM D, YYYY');
              return (
                <div className="trek-row" key={`savedTrek${trek.start_date}${i}`}>
                  <div className="trek-date">
                    {startDate} to {endDate}
                  </div>
                  <div className="trek-name">{trek.title}</div>
                </div>
              );
            })
          )}
        </div>
      </Fragment>
    );
  };

  handleSubmit = async ({ values, setValues, setSubmitting, setErrors }) => {
    const { endpoint, updateData } = this.props;
    try {
      const { data } = await api.patch(endpoint, values);
      setValues({
        ...values,
        upcoming_treks: data.upcoming_treks,
      });
      updateData(data);
      setSubmitting(false);
      getCustomToast('Successfully edited your upcoming trek', 'success');
      this.resetEditor();
    } catch (err) {
      setSubmitting(false);
      getCustomToast('Error trying to edit your upcoming trek', 'error');
      // setErrors(transformMyApiErrors(errors));
    }
  };

  handleSort = ({ values, setValues }) => {
    const sortedTreks = sortByStartDate(values.upcoming_treks);

    setValues({
      ...values,
      upcoming_treks: sortedTreks,
    });
  };

  renderForm = () => {
    const { isViewingOwnProfile, data } = this.props;

    const modifiedDataFormik = isEmpty(data) ? {} : data;

    return (
      <Fragment>
        {isViewingOwnProfile ? (
          <Formik
            initialValues={{ upcoming_treks: [...modifiedDataFormik] }}
            validationSchema={schema}
            onSubmit={(values, { setSubmitting, setErrors, setValues }) => {
              this.handleSubmit({ values, setValues, setSubmitting, setErrors });
            }}
          >
            {({
              values,
              errors,
              isSubmitting,
              handleSubmit,
              setSubmitting,
              setErrors,
              setValues,
            }) => {
              return (
                <Fragment>
                  <h2>
                    UpComing Treks{' '}
                    <div className="edit-box">
                      {this.isSortable(values) ? (
                        <span
                          className="edit"
                          onClick={() => this.handleSort({ values, setValues })}
                        >
                          Sort
                        </span>
                      ) : null}
                      {this.hasInputChanged(values) ? (
                        <span className="edit" onClick={handleSubmit}>
                          Save
                        </span>
                      ) : null}
                      <span className="edit" onClick={this.resetEditor}>
                        Cancel
                      </span>
                    </div>
                  </h2>
                  <div className="upcomming-teks">
                    <div className="trek-row trek-row-head trek-row-edit">
                      <div className="trek-date">Start date - End date</div>
                      <div className="trek-name">Trek name</div>
                      <div className="trek-action">Action</div>
                    </div>
                    <Form>
                      <FieldArray
                        name="upcoming_treks"
                        render={arrayHelpers => (
                          <Fragment>
                            {!isEmpty(values.upcoming_treks) &&
                              values.upcoming_treks.map((singleTrek, index) => (
                                <div
                                  key={`${index}${singleTrek.start_date}`}
                                  className="trek-row trek-row-edit"
                                >
                                  <div className="trek-date">
                                    <Field
                                      render={({
                                        form: { touched, errors, values, setValues },
                                      }) => (
                                        <CustomInputComponent
                                          index={index}
                                          singleTrek={singleTrek}
                                          touched={touched}
                                          errors={errors}
                                          setValues={setValues}
                                          values={values}
                                        />
                                      )}
                                    />
                                  </div>
                                  <div className="trek-name">
                                    <Field
                                      name={`upcoming_treks.${index}.title`}
                                      className="form-control"
                                    />
                                    {errors.upcoming_treks &&
                                      errors.upcoming_treks[index] && (
                                        <p className="error">
                                          {errors.upcoming_treks[index].title}
                                        </p>
                                      )}
                                  </div>
                                  <div className="trek-action">
                                    <button
                                      type="button"
                                      onClick={() => arrayHelpers.remove(index)}
                                      className="btn
                                    btn-secondary"
                                    >
                                      Remove
                                    </button>
                                  </div>
                                </div>
                              ))}
                            <div className="inline-buttons">
                              {isEmpty(errors) ? (
                                <button
                                  type="button"
                                  onClick={() =>
                                    arrayHelpers.push({
                                      start_date: '',
                                      end_date: '',
                                      title: '',
                                    })
                                  }
                                  className="btn btn-secondary"
                                >
                                  Add another trek
                                </button>
                              ) : null}
                              <MobileScreen>
                                {this.hasInputChanged(values) ? (
                                  isSubmitting ? null : (
                                    <button type="submit" className="btn btn-secondary">
                                      Submit
                                    </button>
                                  )
                                ) : null}
                              </MobileScreen>
                            </div>
                          </Fragment>
                        )}
                      />
                    </Form>
                  </div>
                </Fragment>
              );
            }}
          </Formik>
        ) : (
          this.renderUpComingTrek()
        )}
      </Fragment>
    );
  };

  hasInputChanged = values => {
    const { data } = this.props;
    return !isEqual(data ? data : [], values.upcoming_treks);
  };

  isSortable = values => {
    const sortedTreks = sortByStartDate(values.upcoming_treks);

    return (
      values.upcoming_treks &&
      values.upcoming_treks.length > 1 &&
      !isEqual(sortedTreks, values.upcoming_treks)
    );
  };

  handleEditPress = () => this.setState({ isEditing: true });

  resetEditor = () => this.setState({ isEditing: false });
}



// WEBPACK FOOTER //
// ./src/components/Profile/UpCome.js